/**
 * Loyalty-redeem (hűségpont-beváltás) API-kliens (FE-E, Wave-2 / E-105 Phase 3).
 *
 * A csúszka CSAK reserve/preview-t küld (nem spend) — a tényleges pont-levonás a
 * szerződés-véglegesítéskor (commit-spend, a rental-create body `loyaltyRedeem`
 * mezőjén át, a draftId idempotency-kulccsal). A reserve a végleges összeget
 * preview-zi: 50%-cap a rentalGrossAmount-ra + egyenleg-cap, 1 pont = 1 HUF.
 *
 * ⚠️ amount mindig STRING a wire-en (Prisma Decimal→JSON float-drift guard).
 */
import type { LoyaltyRedeemLine, LoyaltyRedeemReserveRequest } from '@kgc/api-contract';
import { api } from './client';

export async function reserveLoyaltyRedeem(
  req: LoyaltyRedeemReserveRequest
): Promise<LoyaltyRedeemLine | null> {
  const response = await api.post<{ data: LoyaltyRedeemLine | null }>(
    '/rentals/loyalty/reserve',
    req
  );
  return response.data;
}

/** A rental-create body `loyaltyRedeem` mezője (commit-spend, rentalId nélkül —
 *  a backend a friss rentalId-re kulcsolja). undefined ha nincs beváltás. */
export interface LoyaltyCommitPayload {
  partnerId: string;
  draftId: string;
  pointsApplied: number;
  amount: string;
}

export function buildLoyaltyCommitPayload(
  line: LoyaltyRedeemLine | null,
  partnerId: string,
  draftId: string
): LoyaltyCommitPayload | undefined {
  if (!line || line.pointsApplied <= 0) return undefined;
  return { partnerId, draftId, pointsApplied: line.pointsApplied, amount: line.amount };
}
